export const resetReservation = () => {
  return {
    type: 'RESET_RESERVATION',
  };
};

export const setReservation = (productInfo) => {
  return {
    type: 'RESERVATION_INFO',
    payload: {
      showId: productInfo.showId,
      showName: productInfo.showName,
      products: productInfo.products,
      performance: productInfo.performance,
      date: productInfo.date,
      paxs: productInfo.paxs,
      callCenter: productInfo.callCenter,
      availabilityRefId: productInfo.availabilityRefId,
      imageUrl: productInfo.imageUrl,
      hasTransportation: productInfo.hasTransportation,
      transfer: productInfo.transfer,
      totalAmount: productInfo.totalAmount,
      specialRequests: productInfo.specialRequests,
      calendar: productInfo.calendar,
      attribute: productInfo.attribute
    },
  };
};

export const setReservationType = (type) => {
  return {
    type: 'SET_RESERVATION_TYPE',
    payload: type,
  };
};

export const setExtraPax = (productInfo) => {
  return {
    type: 'RESERVATION_EXTRA_PAX',
    payload: productInfo,
  };
};

export const setOrderOption = (option) => {
  return {
    type: 'SET_ORDER_OPTION',
    payload: option,
  };
};

export const setDateRange = (dateRange) => {
  return {
    type: 'SET_DATE_RANGE',
    payload: dateRange,
  };
};

export const setTransportation = (tranportation) => {
  return {
    type: 'SET_TRANSPORTATION',
    payload: tranportation,
  };
};

export const resetTransportation = () => {
  return {
    type: 'RESET_TRANSPORTATION',
  };
};

export const updateTransferTrips = (trips) => {
  return {
    type: 'UPDATE_TRANSFER_TRIPS',
    payload: trips,
  };
};

export const addProduct = (product) => {
  return {
    type: 'ADD_PRODUCT',
    payload: product,
  };
};

export const setSellerDiscount = (discount) => {
  return {
    type: 'SET_SELLER_DISCOUNT',
    payload: discount,
  };
};

export const setVoucherCode = (voucherCode) => {
  return {
    type: 'SET_VOUCHER_CODE',
    payload: voucherCode,
  };
};

export const resetVoucherCode = () => {
  return {
    type: 'RESET_VOUCHER_CODE',
  };
};